import { createFileRoute } from "@tanstack/react-router";
import Dashboard from "@/pages/Dashboard";

export const Route = createFileRoute("/en/dashboard")({
  head: () => ({
    meta: [
      { title: "Club Pro | Retail Lemon" },
      {
        name: "description",
        content: "Manage your roadmap, ask Sara AI and track your shop's progress in Retail Lemon.",
      },
      { property: "og:title", content: "Club Pro | Retail Lemon" },
      {
        property: "og:description",
        content: "Roadmap, Retail AI Agent and management tools for your shop.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: Dashboard,
});
